import { GetServerSideProps } from 'next'

import { getRedirectQuery, GetRedirectQueryOutput } from 'app/features/shared/queries'
import {
  StaticContentPagesQueryOutput,
  staticContentPageQuery,
} from 'app/features/static-content/screens/static-content-screen/queries'

import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { StaticContentScreen } from 'app/features/static-content/screens'
import { withAuthedPage } from 'lib/session'

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async ({ req, res, params, query }) => {
    const user = req?.session?.user
    const { slug } = params as { slug: string[] }
    const joinedSlug = slug.join('/')

    const draft = !!query?.preview

    const client = initializeApollo({
      token: user?.token,
      previewToken: query?.token as string,
    })

    const staticContentPages = await client.query<StaticContentPagesQueryOutput>({
      query: staticContentPageQuery,
      variables: {
        slug: joinedSlug,
        draft,
      },
    })

    if (staticContentPages.data?.StaticContentPages?.docs?.[0]) {
      if (!user) {
        res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate')
      }

      return addApolloState(client, {
        props: {
          user: user || null,
          preview: draft,
          previewToken: query?.token || null,
        },
      })
    }

    const redirectRes = await client.query<GetRedirectQueryOutput>({
      query: getRedirectQuery.query,
      variables: { from: `/${joinedSlug}` },
    })

    if (redirectRes.data?.Redirects?.docs?.[0]) {
      console.log('redirecting to', redirectRes.data?.Redirects?.docs?.[0].to)

      return {
        redirect: {
          destination: redirectRes.data?.Redirects?.docs?.[0]?.to || '/',
          permanent: true,
        },
      }
    }

    return {
      notFound: true,
    }
  }
)

export default function Page(props: any) {
  return <StaticContentScreen {...props} />
}
